<template>
  <div class="g-radio">
    <div class="title">{{ question.questionName }}</div>
    <a-radio-group v-model:value="answer" class="gRadio">
      <a-radio
        v-for="(u, idx) in question.options"
        :style="idx !== question.options.length - 1 ? notLastRadio : radioStyle"
        :key="u.id"
        :value="u.optionOrder"
      >
        <span class="radioItem">
          {{ u.optionContent }}
          <text v-if="showScore">{{ `（值${u.optionScore}）` }}</text>
        </span>
      </a-radio>
    </a-radio-group>
  </div>
</template>

<script setup>
import { defineProps, reactive, computed } from 'vue'

const props = defineProps({
  question: {
    type: Object,
    default: () => {}
  },
  showScore: {
    type: Boolean,
    default: true
  }
})

const answer = computed(() => props.question.answerOrder)

const radioStyle = reactive({
  display: 'block',
  width: '600px',
  border: '1px solid rgba(0,0,0,0.15)',
  paddingLeft: '24px'
})
const notLastRadio = {
  ...radioStyle,
  borderBottom: 'none'
}
</script>
<style lang="scss" scoped>
.g-radio {
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 14px;
    color: #333333;
    margin-bottom: 16px;
    width: 600px;
  }
  .gRadio {
    pointer-events: none;
  }
  ::v-deep(.ant-radio-group) {
    .ant-radio-wrapper {
      padding: 15px 0;
    }
  }
  ::v-deep(.ant-radio-inner) {
    border-radius: 0;
  }
  ::v-deep(.ant-radio-inner::after) {
    width: 80%;
    height: 80%;
    border-radius: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background-color: #999999;
  }
  ::v-deep(.ant-radio-checked .ant-radio-inner) {
    border-color: rgba(158, 158, 158, 1);
  }

  ::v-deep(.radioItem) {
    white-space: pre-wrap;
    word-break: break-all;
  }
}
</style>
